import React, { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom'; // Added missing import

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { updateConsultationNote } from '../../../../../../routes/doctor/consultation';
import moment from 'moment';
import { setTitle } from '../../../../../../redux/features/doctor/Dashboard/consultation/consultationNote';

interface Props {
    // Empty props, can be removed if not needed
};

const Title: React.FC<Props> = ({ }) => {

    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const { consultationNoteId } = useParams(); // Now correctly sourced

    const colors = useAppSelector(state => state.theme.colors);
    const info = useAppSelector(state => state.consultationNote.info);
    const securityPin = useAppSelector(state => state.consultation.securityPin);
    const titleFromRedux = useAppSelector(state => state.consultationNote.title);

    const [createdAt, setCreatedAt] = useState('');

    // --

    const onTextChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const newTitle = e.target.value;

        // Dispatch setTitle to update the Redux store
        dispatch(setTitle(newTitle));

        if (consultationNoteId && securityPin) {
            const content = {
                consultationNoteId: consultationNoteId,
                securityPin: securityPin,
                title: newTitle
            };
            // Consider debouncing this API call if it's made too frequently
            updateConsultationNote(content);
        }
    };

    // --

    useEffect(() => {
        if (info && info.createdAt) {
            setCreatedAt(moment(info.createdAt).utc(true).format('LT'));
        } else {
            setCreatedAt('');
        }
    }, [info]);

    // --
    // The following useEffects were commented out in your provided code.
    // If their logic is needed (e.g., clearing title on note change), they can be reinstated.
    /*
    useEffect(() => {
        if (titleFromRedux) {
            // setText(titleFromRedux); // Local state 'text' was removed
        };
    },[titleFromRedux]);
    */

    /*
    useEffect(() => {
        if (consultationNoteId) {
            // setText(''); // Local state 'text' was removed
            // If you need to clear the title in Redux when the note ID changes:
            // dispatch(setTitle(''));
        };
    },[consultationNoteId, dispatch]);
    */

    // --

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                paddingX: 2,
                marginTop: 2,
                color: colors?.main,
            }}
        >
            <TextField
                id="note-title"
                variant="standard"
                value={titleFromRedux} // Value is correctly bound to Redux state
                autoComplete="off"
                placeholder={String(t('addTitle', 'Add title...'))}
                sx={{
                    flexGrow: 1,
                    marginRight: 2,
                }}
                inputProps={{
                    style: {
                        textAlign: 'left',
                        fontSize: 16,
                        color: colors?.text,
                        whiteSpace: 'nowrap',
                        overflowX: 'auto',
                    }
                }}
                InputProps={{
                    disableUnderline: true,
                }}
                onChange={onTextChange} // Handler correctly dispatches setTitle
            />

            <Box
                sx={{
                    fontSize: 14,
                    color: 'rgb(150, 150, 150)',
                    whiteSpace: 'nowrap'
                }}
            >{createdAt}
            </Box>
        </Box>
    );
};

export default Title;